import angular from 'angular';
import services from '../services';
import roles from '@updater/angular-roles';
import { compose } from 'redux';
import { selectors } from '../../../state';
import { STATES } from '../../../constants';

export default angular
  .module('app.roles', [roles.name, services.name])
  .run(defineRoles);

// Permission roles definition
// ------------------
function defineRoles(Permission, updStore, appShell) {
  'ngInject';
  const { getState } = updStore;

  Permission.defineRole({
    name: 'signedIn',
    validation: compose(
      selectors.session.isSignedIn,
      getState
    ),
    redirect: () => wasNegated =>
      wasNegated ? STATES.DASHBOARD : STATES.SIGN_IN,
  });

  Permission.defineRole({
    name: 'signingUp',
    validation: compose(
      selectors.signUp.isSigningUp,
      getState
    ),
    redirect: STATES.WELCOME,
  });

  Permission.defineRole({
    name: 'invited',
    validation: compose(
      selectors.signUp.isInvited,
      getState
    ),
    redirect: () => wasNegated => {
      if (wasNegated) {
        return {
          name: STATES.INVITE,
          params: {
            inviteToken: selectors.signUp.inviteToken(getState()),
          },
        };
      }
    },
  });

  // Must add `confirmState` state `data` property to tell redirect where to go
  // if `moveConfirmed` isn't allowed.
  Permission.defineRole({
    name: 'moveConfirmed',
    validation: () => {
      const state = getState();
      return selectors.current.move(state).isValid(state);
    },
    redirect: $state => {
      'ngInject';
      return wasNegated => {
        const { data, name } = $state.next;
        return wasNegated
          ? data.afterConfirmState || name.replace('.confirm', '')
          : data.confirmState;
      };
    },
  });

  // Must add `hasOwnership` state `data` property to tell redirect where to go
  // if `hasOwnership` isn't allowed.
  Permission.defineRole({
    name: 'hasOwnership',
    validation: () => {
      const state = getState();
      return selectors.current.move(state).hasOwnership(state);
    },
    redirect: $state => {
      'ngInject';
      return wasNegated => {
        const { data, name } = $state.next;
        debugger;
        return wasNegated
          ? data.afterConfirmState || name.replace('.confirm', '')
          : data.confirmState;
      };
    },
  });

  // Must add `verifyState` state `data` property to tell redirect where to go
  // if `needToVerify` isn't allowed.
  Permission.defineRole({
    name: 'needToVerify',
    validation: () => {
      const state = getState();
      return selectors.current.move(state).needToVerify(state);
    },
    redirect: $state => {
      'ngInject';
      return wasNegated => {
        const stateName = $state.next.name;
        const { data } = $state.next;
        return wasNegated
          ? data.verifyState
          : data.afterVerifyState || stateName.replace('.verify', '');
      };
    },
  });

  Permission.defineRole({
    name: 'military',
    validation: () => {
      const state = getState();
      return selectors.current.move(state).isMilitary(state);
    },
    redirect: $state => {
      'ngInject';
      return wasNegated => {
        const { data, name } = $state.next;
        return wasNegated
          ? data.militaryState
          : data.afterMilitaryState || name.replace('.military', '');
      };
    },
  });

  Permission.defineRole({
    name: 'hasFyms',
    validation: compose(
      selectors.current.hasForwardMailItems,
      getState
    ),
    redirect: STATES.STEP_FORWARD_MAIL_NEW,
  });

  Permission.defineRole({
    name: 'haveShare',
    validation: compose(
      selectors.current.hasShareMoveItem,
      getState
    ),
    redirect: STATES.STEP_SHARE_MOVE_CUSTOMIZE,
  });

  Permission.defineRole({
    name: 'hasAccessToAccountFeatures',
    validation: () => {
      const journey = appShell.interactors.journey;
      return journey.selectors.hasAccessToAccountFeatures(journey.getState());
    },
  });

  // Not strictly necessary since the lack of roles for a state means the same thing.
  // However, can be useful from a readability perspective.
  Permission.defineRole({
    name: 'anyone',
    validation: () => true,
  });
}
